import ArtSoc from './art-societe.json';
import assMat2 from './ass-mat-v3.json';
import assMat from './ass-mat.json';
import bacTest from './bac-test.json';
import dnbRev from './brevet-revision.json';
import artCritiqueSociale from './cases/artistique/art-critique-sociale.json';
import critiqueSystemique from './cases/education/critique-systemique.json';
import conflitsInternes from './cases/entreprise/conflits-internes.json';
import evenementielDevelopementLocal from './cases/entreprise/evenementiel-developpement-local.json';
import corpsLang from './corps-langage.json';
import educationSociete from './education-societe.json';
import engCit from './engagement-citoyen.json';
import lienTransm from './lien-transmission.json';
import ventCom from './vente-commerce.json';
//import locConf from './location-conflit.json';
import accompEnf from './accompagnement-enfance.json';
import accompEnfMed from './civilisation-education.json';
import parentEmp from './parent-employeur.json';
import parentaliteMission from './parentalite-mission.json';
import protEnf from './protection-enfance.json';
import voieSoup from './voie-souplesse.json';

import immoGestion from './immobilier-gestion.json';
import critiqueTransformation from './parcours/education/critique-transformation.json';
import penseeCritique from './parcours/education/pensee-critique.json';
import deAES from './parcours/formation/de-aes.json';
import orientationIdentite from './parcours/orientation/orientation-identite.json';

import retinaView from './retina-view.json';
import financeTemps from './finance-temps.json';


export const templates = {
  'critique-systemique': critiqueSystemique,
  'orientation-identite': orientationIdentite,
  'art-critique-sociale': artCritiqueSociale, 
  'conflits-internes': conflitsInternes, 
  'evenementiel-developpement-local': evenementielDevelopementLocal,
  
  'pensee-critique': penseeCritique,
  'critique-transformation': critiqueTransformation,
  
  'de-aes': deAES,
 
  'bac-test': bacTest,
  'ass-mat': assMat,
  'ass-mat-v3': assMat2,  
  'education-societe': educationSociete,
  'immobilier-gestion': immoGestion,
  'parentalite-mission': parentaliteMission,
  'art-societe': ArtSoc,
  'lien-transmission': lienTransm,
  'corps-langage': corpsLang,
  'brevet-revision': dnbRev,
  'engagement-citoyen': engCit,
  'protection-enfance': protEnf,
  'parent-employeur': parentEmp,
  //'location-conflit': locConf,
  'voie-souplesse': voieSoup,
  'accompagnement-enfance': accompEnf,
  'accompagnement-enfance-mediateurs': accompEnfMed,
  'vente-commerce': ventCom,
  'retina-view': retinaView,
  'finance-temps': financeTemps,
};